import React from 'react';
import PropTypes from 'prop-types';

class WorkExperienceItem extends React.Component {

  render() {
    const { children, place, location, title, time } = this.props;

    return (
      <div className="item">
        <div className="work-place">
          <h3 className="place">{place}</h3>
          <div className="location">
            <i className="fa fa-map-marker" aria-hidden="true" />
            {location}
          </div>
        </div>
        <div className="job-meta">
          <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
          <div className="time">{time}</div>
        </div>
        <div className="job-desc">
          {children}
        </div>
      </div>
    );
  }
}

WorkExperienceItem.propTypes = {
  children: PropTypes.any,
  place: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};

export default WorkExperienceItem;



// WEBPACK FOOTER //
// ../components/Blocks/WorkExperienceItem.jsx